import type { FoundationComponentEntity } from "building-types/foundations/foundationComponentEntityTypes";
import { fixedWidthCurbNew } from "building-types/foundations/foundationComponents";
import { FoundationSubSystemType } from "building-types/foundations/foundationEnums";
import type { FoundationSystemSettings } from "building-types/settings/foundationSettingsTypes";
import type { Table } from "common/data/table";

export const CURB_GARAGE_COMPONENT_ID = "GARAGE-CURB";

// We have to have this function because the CURB_GARAGE builtin is a function of the foundationSettings.garageCurbWidth
// Therefore we need to call this at the top level during building generation to make sure that built-in is available.
// We should probably migrate this so that the CURB_GARAGE isn't a special case, then we can remove this function.
export function finalizeFoundationComponents(
  foundationComponents: Table<FoundationComponentEntity>,
  foundationSettings: FoundationSystemSettings,
): Table<FoundationComponentEntity> {
  if (foundationSettings.foundationSubSystemType !== FoundationSubSystemType.MONOLITHIC) {
    return foundationComponents;
  }
  const curbGarage = fixedWidthCurbNew(CURB_GARAGE_COMPONENT_ID, foundationSettings.garageCurbWidth);
  return {
    ...foundationComponents,
    [CURB_GARAGE_COMPONENT_ID]: curbGarage,
  };
}
